import React from 'react';
import Icon from '@mdi/react';

const KenIcon = (props) => {
  const {
    variant = '',
    icon: CustomIcon,
    styles = {},
    iconType = '',
    alt = '',
    path,
    mdiIconProps,
    src,
  } = props;
  const getStyles = (typeOfIcon) => {
    if (typeOfIcon === 'img') {
      switch (variant) {
        case 'extraSmall':
          return { height: 16, width: 16 };
        case 'small':
          return { height: 24, width: 24 };
        case 'medium':
          return { height: 32, width: 32 };
        case 'large':
          return { height: 40, width: 40 };
        case 'extraLarge':
          return { height: 56, width: 56 };

        default:
          return { height: 24, width: 24 };
      }
    } else if (typeOfIcon === 'mdi') {
      switch (variant) {
        case 'extraSmall':
          return { size: '16px' };
        case 'small':
          return { height: 24, width: 24 };
        case 'medium':
          return { size: '32px' };
        case 'large':
          return { size: '40px' };
        case 'extraLarge':
          return { size: '48px' };

        default:
          return { size: '24px' };
      }
    } else {
      switch (variant) {
        case 'extraSmall':
          return { fontSize: '8px' };
        case 'medium':
          return { fontSize: '24px' };
        case 'large':
          return { fontSize: '32px' };
        case 'extraLarge':
          return { fontSize: '40px' };

        default:
          return { fontSize: '16px' };
      }
    }
  };

  const getIcon = () => {
    switch (iconType) {
      case 'img':
        return (
          <img
            src={src}
            style={{ ...getStyles('img'), ...styles }}
            {...props}
          />
        );
      case 'mdi':
        return (
          <Icon
            path={path}
            title={alt}
            color="white"
            {...getStyles('mdi')}
            {...mdiIconProps}
          />
        );

      default:
        return (
          <CustomIcon
            style={{ ...getStyles('default'), ...styles }}
            {...props}
          />
        );
    }
  };

  return <>{getIcon()}</>;
};
export default KenIcon;
